import { cn } from "@/lib/cn";

export type SpinnerProps = {
  size?: "sm" | "md" | "lg";
  className?: string;
  label?: string;
};

const sizeMap = {
  sm: "bfrs-size-4",
  md: "bfrs-size-5",
  lg: "bfrs-size-7"
};

export function Spinner({ size = "md", className, label = "Loading" }: SpinnerProps) {
  return (
    <span role="status" aria-label={label} className={cn("bfrs-inline-block bfrs-animate-spin bfrs-rounded-pill bfrs-border-2 bfrs-border-current bfrs-border-t-transparent", sizeMap[size], className)} />
  );
}
